var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHomeFill = function SvgHomeFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 19v-9a1.99 1.99 0 0 1 .8-1.6l6-4.5q.525-.4 1.2-.4t1.2.4l6 4.5q.375.275.588.7T20 10v9q0 .824-.587 1.413A1.93 1.93 0 0 1 18 21h-3a.97.97 0 0 1-.713-.288A.97.97 0 0 1 14 20v-5a.97.97 0 0 0-.287-.713A.97.97 0 0 0 13 14h-2a.97.97 0 0 0-.713.287A.97.97 0 0 0 10 15v5q0 .424-.287.712A.97.97 0 0 1 9 21H6q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 19"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHomeFill);
export { ForwardRef as ReactComponent };